module.exports = __webpack_public_path__ + "assets/img/MyBox.0744b762.png";